import s from './Map.module.css';
import type { IPhase, ITask } from '../data/types';
import { getPhaseMetrics } from '../utils/progress';

interface IPhaseGroupProps {
  phase: IPhase;
  tasks: ITask[];
  isDimmed: boolean;
}

const PADDING_X = 28;
const PADDING_Y = 36;
const NODE_W = 168;
const NODE_H = 92;

export const PhaseGroup = ({ phase, tasks, isDimmed }: IPhaseGroupProps) => {
  if (tasks.length === 0) return null;

  const xs = tasks.map((t) => t.position.x);
  const ys = tasks.map((t) => t.position.y);
  const minX = Math.min(...xs) - PADDING_X;
  const minY = Math.min(...ys) - PADDING_Y;
  const maxX = Math.max(...xs) + NODE_W + PADDING_X;
  const maxY = Math.max(...ys) + NODE_H + PADDING_Y;

  const metrics = getPhaseMetrics(phase);

  return (
    <>
      <div
        className={`${s.phaseGroup} ${isDimmed ? s.dimmed : ''}`}
        style={{
          left: minX,
          top: minY,
          width: maxX - minX,
          height: maxY - minY,
          background: phase.accent,
        }}
      >
        <span className={s.phaseGroupLabel}>
          Фаза {phase.index} · {phase.title}
        </span>
      </div>
      <div
        className={s.phaseHero}
        style={{
          left: phase.heroPosition.x,
          top: phase.heroPosition.y,
          opacity: isDimmed ? 0.4 : 1,
        }}
      >
        <div className={s.phaseHeroIndex} style={{ background: phase.color }} aria-hidden="true">
          {phase.index}
        </div>
        <div className={s.phaseHeroBody}>
          <span className={s.phaseHeroTitle}>{phase.title}</span>
          <span className={s.phaseHeroSub}>{phase.subtitle}</span>
          <div className={s.phaseHeroBar}>
            <div
              className={s.phaseHeroBarFill}
              style={{
                width: `${metrics.percent}%`,
                background: `linear-gradient(90deg, ${phase.color}, ${phase.color}80)`,
              }}
            />
          </div>
          <span className={s.phaseHeroPercent}>
            {metrics.percent}% · {metrics.done}/{metrics.total} задач
          </span>
        </div>
      </div>
    </>
  );
};
